import React from 'react';
import { motion } from 'framer-motion';
import { X, Check, ArrowRight } from 'lucide-react';
const beforeItems = ['Mente acelerada que no para', 'Insomnio y noches sin descanso', 'Pecho apretado y tensión constante', 'Miedo sin razón aparente', 'Reacciones impulsivas', 'Saturación y agotamiento mental'];
const afterItems = ['Mente en paz y silencio interior', 'Sueño profundo y reparador', 'Cuerpo relajado y liviano', 'Estabilidad emocional real', 'Claridad para tomar decisiones', 'Control interno y seguridad'];
export function TransformationSection() {
  return <section className="py-24 bg-beige relative overflow-hidden" data-id="element-136">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold/20 to-transparent" data-id="element-137"></div>
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold/20 to-transparent" data-id="element-138"></div>

      <div className="max-w-5xl mx-auto px-6" data-id="element-139">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-140">
          <h2 className="text-3xl md:text-4xl font-serif text-navy mb-4" data-id="element-141">
            Tu transformación en 21 días
          </h2>
          <div className="w-16 h-0.5 bg-gold mx-auto" data-id="element-142"></div>
        </motion.div>

        <div className="flex flex-col md:flex-row items-stretch gap-8 lg:gap-12 relative" data-id="element-143">
          {/* Arrow indicator (desktop) */}
          <div className="hidden md:flex absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-white rounded-full items-center justify-center shadow-sm border border-beige-dark z-10 text-gold" data-id="element-144">
            <ArrowRight size={24} data-id="element-145" />
          </div>

          {/* ANTES */}
          <motion.div className="flex-1 bg-white/60 backdrop-blur-sm p-8 md:p-10 rounded-3xl border border-red-900/5" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} data-id="element-146">
            <h3 className="text-xl font-serif text-slate mb-8 flex items-center gap-3" data-id="element-147">
              <span className="w-8 h-8 rounded-full bg-red-50 flex items-center justify-center text-red-400 text-sm" data-id="element-148">
                A
              </span>
              ANTES
            </h3>
            <ul className="space-y-5" data-id="element-149">
              {beforeItems.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-150">
                  <div className="mt-1 text-red-400/70 shrink-0" data-id="element-151">
                    <X size={18} strokeWidth={2} data-id="element-152" />
                  </div>
                  <span className="text-slate-light" data-id="element-153">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* DESPUÉS */}
          <motion.div className="flex-1 bg-white p-8 md:p-10 rounded-3xl shadow-premium border border-emerald-300/20 relative overflow-hidden" initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-154">
            {/* Subtle highlight */}
            <div className="absolute top-0 right-0 w-32 h-32 bg-emerald-200/20 rounded-full blur-2xl -translate-y-1/2 translate-x-1/2 pointer-events-none" data-id="element-155"></div>

            <h3 className="text-xl font-serif text-navy mb-8 flex items-center gap-3 relative z-10" data-id="element-156">
              <span className="w-8 h-8 rounded-full bg-emerald-100 flex items-center justify-center text-emerald-600 text-sm" data-id="element-157">
                D
              </span>
              DESPUÉS
            </h3>
            <ul className="space-y-5 relative z-10" data-id="element-158">
              {afterItems.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-159">
                  <div className="mt-1 text-emerald-500 shrink-0" data-id="element-160">
                    <Check size={18} strokeWidth={2.5} data-id="element-161" />
                  </div>
                  <span className="text-navy font-medium" data-id="element-162">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}